import Joi from 'joi';
  
    
export const VALIDATION_PROJECTS_SEARCH = {
    options: {allowUnknownBody: false},
    body: {
        name                                    :Joi.string(),
        projectType                             :Joi.string(),
        projectSubType                          :Joi.string(),
        workType                                :Joi.string(),
        district                                :Joi.string(),
        city                                    :Joi.array().items(Joi.string()),
        country                                 :Joi.string(),
        minBudget                               :Joi.number(),
        maxBudget                               :Joi.number(),
        investmentType                          :Joi.string(),
        minContructionArea                      :Joi.number(),
        maxContructionArea                      :Joi.number(),
        minLandArea                             :Joi.number(),
        maxLandArea                             :Joi.number(),
        totalFloorArea                          :Joi.number(),
        state                                   :Joi.string(),
        status                                  :Joi.string(),
        minStartTime                            :Joi.date(),
        maxStartTime                            :Joi.date(),
        minFinishTime                           :Joi.date(),
        maxFinishTime                           :Joi.date(),
        page:Joi.number().min(1),
        // orderBy: Joi.string().valid('updatedAt','createdAt', ProjectFields.maxBudget).required(),
        orderType: Joi.string().valid('ASC','DESC').required(),
        filterFollow:Joi.boolean(),
    }
}

export const VALIDATION_PROJECTS_CREATE = {
    options: {allowUnknownBody: false},
    body: {
        name                                    :Joi.string().min(5).required(),
        description                             :Joi.string().min(5),
        documents                               :Joi.array().items(Joi.object()),
        listVideos                              :Joi.array().items(Joi.string()),
        listImages                              :Joi.array().items(Joi.string()),
        projectType                             :Joi.string(),
        projectSubType                          :Joi.string(),
        workType                                :Joi.string(),
        location                                :Joi.object(),
        address                                 :Joi.string().required(),
        village                                 :Joi.string(),
        district                                :Joi.string().required(),
        city                                    :Joi.string().required(),
        country                                 :Joi.string().required(),
        minBudget                               :Joi.number(),
        maxBudget                               :Joi.number(),
        investmentType                          :Joi.string(),
        minConstructionArea                      :Joi.number(),
        maxConstructionArea                      :Joi.number(),
        minLandArea                             :Joi.number().min(1).max(2000000000),
        maxLandArea                             :Joi.number().min(1).max(2000000000),
        totalFloorArea                          :Joi.number().min(1).max(2000000000),
        state                                   :Joi.string(),
        status                                  :Joi.string(),
        minStartTime                            :Joi.date(),
        maxStartTime                            :Joi.date(),
        minFinishTime                           :Joi.date(),
        maxFinishTime                           :Joi.date(),
        purpose                                 :Joi.string(),

        // typeOfContractor: Validation.ARRAY_TYPE_OF_CONTRACTOR,
        // typeOfConstruction: Validation.TYPE_OF_CONTRUCTION,
        // typeOfProject: Validation.TYPE_OF_PROJECT,
        // name: Validation.NAME.required(),
        // address: Validation.ADDRESS.required(),
        // location: Validation.LOCATION,
        // city: Validation.CITY.required(),
        // country: Validation.COUNTRY.required(),
        // district: Validation.DISTRICT.required(),
        // phase: Validation.PHASE,// Giai đoạn của dự án bao gồm [chuẩn bị, đấu thầu, thi công, hoàn thành
        // startBuildTime: Validation.DATE,
        // endBuildTime: Validation.DATE,
        // startBuildTimeMin: Validation.DATE,
        // startBuildTimeMax: Validation.DATE,
        // endBuildTimeMin: Validation.DATE,
        // endBuildTimeMax: Validation.DATE,
        //
        // fromBudget: Validation.BUGET,
        // endBudget: Validation.BUGET,
        // unitBugget: Validation.CURRENCY_UNIT,
        //
        // typeOfInvestment: Validation.TYPE_OF_INVESTMENT,
        //
        // startScheduled: Validation.DATE,
        // endScheduled: Validation.DATE,
        //
        // bidSolicitor: Validation.BIDDING_SOLICITOR, //ID Các bên mên mời thầu
        //
        // biddingForm: Joi.number(), //Hình thức đấu thầu
        //
        // countryOfContractor: Validation.COUNTRY,
        // districtOfContractor: Validation.COUNTRY,
        //
        // bidOpenTime: Validation.DATE, // Thời gian mở thầu
        // bidCloseTime: Validation.DATE, // Thời gian đóng thầu
        //
        // minimumExperienceOfContractor: Joi.number(),
        // creditRatingOfContractor: Validation.RANKING,// Mức tín nhiệm
        // minimumRevenueOfContractor: Validation.REVENUE,//
        // unitRevenueOfContractor: Validation.CURRENCY_UNIT,
        // otherRequirements: Joi.string(),
        // listImage: Joi.array().items(Joi.string()).min(0).required(),
        // listVideo: Joi.array().items(Joi.string()).min(0).required(),
        // investment: Validation.INVESTMENT,
        // unitInvestment: Validation.CURRENCY_UNIT,
        //
        //
        // areaOfLandMin: Validation.AREA, // Dien tich dat
        // areaOfLandMax: Validation.AREA, // Dien tich dat
        // unitAreaOfLand: Validation.AREA_UNIT,
        //
        // contructionAreaMin: Validation.AREA,//Dien tich xay dung
        // contructionAreaMax: Validation.AREA,//Dien tich xay dung
        // unitContructionArea: Validation.AREA_UNIT,
        // projectMaterials:Joi.array().items(Joi.object()).min(0).required(),
        // projectDocuments:Joi.array().items(Joi.object()).min(0).required(),
        //
        // stage: Joi.string(),
        // status: Joi.string(),
        // propertyType: Joi.string(),
        // subPropertyType: Joi.string(),
        // purpose: Joi.string(),
        // ownerRoll: Joi.string(),
        // description: Joi.string(),
    }
}

export const VALIDATION_PROJECTS_DETAIL_ONE = {
    options: {allowUnknownBody: false},
    params: {
        id: Joi.number().required()
    }
}

export const VALIDATION_PROJECTS_UPDATE = {
    options: {allowUnknownBody: false},
    body: {
      name: Joi.string().min(5),
      description: Joi.string(),
      documents: Joi.array().items(Joi.object()),
      listVideos: Joi.array().items(Joi.string()),
      listImages: Joi.array().items(Joi.string()),
      projectType: Joi.string(),
      projectSubType: Joi.string(),
      workType: Joi.string(),
      location: Joi.object(),
      address: Joi.string(),
      village: Joi.string(),
      district: Joi.string(),
      city: Joi.string(),
      country: Joi.string(),
      minBudget: Joi.number(),
      maxBudget: Joi.number(),
      investmentType: Joi.string(),
      minConstructionArea: Joi.number().min(1).max(2000000000),
      maxConstructionArea: Joi.number().min(1).max(2000000000),
      minLandArea: Joi.number().min(1).max(2000000000),
      maxLandArea: Joi.number().min(1).max(2000000000),
      totalFloorArea: Joi.number().min(1).max(2000000000),
      state: Joi.string(),
      stage: Joi.string(),
      status: Joi.string(),
      minStartTime: Joi.date(),
      maxStartTime: Joi.date(),
      minFinishTime: Joi.date(),
      maxFinishTime: Joi.date(),
      purpose: Joi.string()
    }
};

export const VALIDATION_APPROVED_PROJECT = {
    options: {allowUnknownBody: false},
    body: {
        id                                      : Joi.string().required(),
        approved                                : Joi.number().required()
    }
};

export const VALIDATION_ADMIN_LIST_PROJECTS = {
    options: {allowUnknownBody: false},
    body: {
        approved                                : Joi.boolean().required(),
        name                                    :Joi.string(),
        projectType                             :Joi.string(),
        projectSubType                          :Joi.string(),
        workType                                :Joi.string(),
        district                                :Joi.string(),
        city                                    :Joi.array().items(Joi.string()),
        country                                 :Joi.string(),
        minBudget                               :Joi.number(),
        maxBudget                               :Joi.number(),
        investmentType                          :Joi.string(),
        minContructionArea                      :Joi.number(),
        maxContructionArea                      :Joi.number(),
        minLandArea                             :Joi.number(),
        maxLandArea                             :Joi.number(),
        totalFloorArea                          :Joi.number(),
        state                                   :Joi.string(),
        status                                  :Joi.string(),
        minStartTime                            :Joi.date(),
        maxStartTime                            :Joi.date(),
        minFinishTime                           :Joi.date(),
        maxFinishTime                           :Joi.date(),
        page:Joi.number().min(1),
        // orderBy: Joi.string().valid('updatedAt','createdAt', ProjectFields.maxBudget).required(),
        orderType: Joi.string().valid('ASC','DESC').required(),
    }
};

export const VALIDATION_DEACTIVE_PROJECT = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.string().required(),
  }
};



// WEBPACK FOOTER //
// ./src/services/project/Project.Validator.js